import { createFileRoute, redirect } from '@tanstack/react-router'
import OrganizationLogoTab from '@admin/preferences/navigationBar/OrganizationLogoTab'

export const Route = createFileRoute('/_auth/preferences/navigation-bar/org-logo')({
  component: RouteComponent,
  beforeLoad: ({ context: { scopedEnablements } }) => {
    if (!scopedEnablements.global().hasStandardEnablement('Organization', 'MANAGE')) {
      throw redirect({
        to: '/403',
        replace: true,
      })
    }
  },
})

function RouteComponent() {
  return <OrganizationLogoTab />
}
